function getDefaultState() {
  return {
    params: {
      payment_year_month: '',
      kitchen_id: null
    },
    invoiceList: [],
    selectedInvoice: {
      year_month: '',
      total: null,
      invoices: []
    }
  }
}
import axios from 'axios'
export default {
  namespaced: true,
  state: {
    params: {
      payment_year_month: '',
      kitchen_id: null
    },
    invoiceList: [],
    selectedInvoice: {
      year_month: '',
      total: null,
      invoices: []
    }
  },
  getters: {
    invoiceList(state) {
      return state.invoiceList
    },
    invoice(state) {
      return state.selectedInvoice
    },
    params(state) {
      return state.params
    },
    invoiceYearMonth(state) {
      if (!state.params.payment_year_month) {
        return null
      }
      const tempYear = state.params.payment_year_month.slice(0, 4)
      const tempMonth = state.params.payment_year_month.slice(4)
      const tempYearMonth = tempYear + '-' + tempMonth
      return tempYearMonth
    }
  },
  mutations: {
    setParams(state, data) {
      state.params = data
    },
    setInvoiceList(state, data) {
      state.invoiceList = []
      state.selectedInvoice = {
        year_month: '',
        total: null,
        invoices: []
      }
      const dueDateText = navigator.language === 'ja' ? '支払期限' : 'Due Date'
      const withdrawalText = navigator.language === 'ja' ? '振替日' : 'Transfer Date'
      const depositText = navigator.language === 'ja' ? 'ご精算予定' : 'Settlement with deposit'
      if (data.length > 0) {
        for (var i of data) {
          var title = i.kitchen_name + ' (' + dueDateText + ': ' + i.due_date + ')'
          if (i.is_auto_withdrawal) {
            title = i.kitchen_name + ' (' + withdrawalText + ': ' + i.due_date + ')'
          }
          if (i.is_deposit) {
            title = i.kitchen_name + ' (' + depositText + ')'
          }
          state.invoiceList.push({
            id: i.id,
            title: title
          })
        }
      }
    },
    setInvoice(state, data) {
      state.selectedInvoice = data
    },
    clearState(state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    setParams({ commit }, data) {
      commit('setParams', data)
    },
    async getInvoiceList({ commit }, data) {
      await axios
        .get('/invoices/list?payment_year_month=' + data.payment_year_month)
        .then((response) => {
          commit('setInvoiceList', response.data.data)
        })
        .catch((error) => {
          console.log('catch : error :' + error)
        })
    },
    async getInvoice({ commit }, invoiceId) {
      await axios
        .get('/invoices/detail?id=' + invoiceId)
        .then((response) => {
          commit('setInvoice', response.data.data)
        })
        .catch((error) => {
          console.log('catch : error :' + error)
        })
    },
    clearState({ commit }) {
      commit('clearState')
    }
  }
}
